export default __webpack_public_path__ + "static/media/WhatsappImage.ad908513.png";